import React, { useState, useContext } from 'react';
import { LanguageContext } from '../App';
import { SearchIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, UserIcon, EyeIcon, Ban, CheckCircle2Icon, FilterIcon, BriefcaseIcon, UserCircleIcon, PlusIcon, DownloadIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { pageTransition, fadeIn, slideUp, staggerContainer, listItem, buttonHover, buttonTap } from '../utils/animations';
export const Users: React.FC = () => {
  const {
    language,
    direction
  } = useContext(LanguageContext);
  const [filters, setFilters] = useState({
    status: 'all',
    timeFrame: 'all',
    userType: 'all'
  });
  const [searchTerm, setSearchTerm] = useState('');
  const handleFilterChange = (filterType: string, value: string) => {
    setFilters({
      ...filters,
      [filterType]: value
    });
  };
  const users = [{
    id: 'USR-5623',
    name: 'Ahmed Al-Sabah',
    phone: '+965 9876 5432',
    email: 'ahmed@example.com',
    totalOrders: 28,
    walletBalance: 'KWD 120.50',
    savedAddresses: 3,
    status: 'active',
    type: 'personal'
  }, {
    id: 'USR-5622',
    name: 'Fatima Al-Qadiri',
    phone: '+965 9876 1234',
    email: 'fatima@example.com',
    totalOrders: 15,
    walletBalance: 'KWD 75.25',
    savedAddresses: 2,
    status: 'active',
    type: 'personal'
  }, {
    id: 'USR-5621',
    name: 'Mohammed Al-Mutairi',
    phone: '+965 9876 7890',
    email: 'mohammed@example.com',
    totalOrders: 42,
    walletBalance: 'KWD 210.00',
    savedAddresses: 5,
    status: 'active',
    type: 'business'
  }, {
    id: 'USR-5620',
    name: 'Sarah Al-Enezi',
    phone: '+965 9876 4567',
    email: 'sarah@example.com',
    totalOrders: 8,
    walletBalance: 'KWD 45.75',
    savedAddresses: 1,
    status: 'active',
    type: 'personal'
  }, {
    id: 'USR-5619',
    name: 'Abdullah Al-Rashidi',
    phone: '+965 9876 3456',
    email: 'abdullah@example.com',
    totalOrders: 19,
    walletBalance: 'KWD 85.00',
    savedAddresses: 2,
    status: 'blocked',
    type: 'personal'
  }, {
    id: 'USR-5618',
    name: 'Noura Al-Ali',
    phone: '+965 9876 2345',
    email: 'noura@example.com',
    totalOrders: 31,
    walletBalance: 'KWD 150.25',
    savedAddresses: 4,
    status: 'active',
    type: 'business'
  }, {
    id: 'USR-5617',
    name: 'Khalid Al-Enezi',
    phone: '+965 9876 8765',
    email: 'khalid@example.com',
    totalOrders: 12,
    walletBalance: 'KWD 60.50',
    savedAddresses: 2,
    status: 'active',
    type: 'business'
  }, {
    id: 'USR-5616',
    name: 'Maryam Al-Sabah',
    phone: '+965 9876 9876',
    email: 'maryam@example.com',
    totalOrders: 5,
    walletBalance: 'KWD 25.00',
    savedAddresses: 1,
    status: 'active',
    type: 'personal'
  }];
  // Filter users based on filters
  const filteredUsers = users.filter(user => {
    const matchesStatus = filters.status === 'all' || user.status === filters.status;
    const matchesType = filters.userType === 'all' || user.type === filters.userType;
    const matchesSearch = !searchTerm || user.name.toLowerCase().includes(searchTerm.toLowerCase()) || user.id.toLowerCase().includes(searchTerm.toLowerCase()) || user.email.toLowerCase().includes(searchTerm.toLowerCase()) || user.phone.includes(searchTerm);
    return matchesStatus && matchesType && matchesSearch;
  });
  return <motion.div className="space-y-5" variants={pageTransition} initial="hidden" animate="visible" exit="exit" data-id="element-1368">
      <motion.div className="flex justify-between items-center" variants={slideUp} data-id="element-1369">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-1370">
          {language === 'en' ? 'Users' : 'المستخدمين'}
          <span className="ml-2 text-sm font-medium text-gray-500" data-id="element-1371">
            {filteredUsers.length} {language === 'en' ? 'total' : 'إجمالي'}
          </span>
        </h2>
        <motion.div className="flex items-center space-x-2" variants={staggerContainer} data-id="element-1372">
          <motion.button className="px-3 py-1.5 text-sm border border-gray-300 rounded-md flex items-center text-gray-700 hover:bg-gray-50 transition-colors" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-1373">
            <DownloadIcon size={14} className="mr-1" data-id="element-1374" />
            {language === 'en' ? 'Export' : 'تصدير'}
          </motion.button>
          <motion.button className="px-3 py-1.5 text-sm bg-congress-blue-600 text-white rounded-md flex items-center hover:bg-congress-blue-700 transition-colors" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-1375">
            <PlusIcon size={14} className="mr-1" data-id="element-1376" />
            {language === 'en' ? 'Add User' : 'إضافة مستخدم'}
          </motion.button>
        </motion.div>
      </motion.div>
      <motion.div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" variants={fadeIn} data-id="element-1377">
        <motion.div className="px-4 py-3 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" variants={slideUp} data-id="element-1378">
          <motion.div className="relative w-full sm:w-64" initial={{
          opacity: 0,
          width: '90%'
        }} animate={{
          opacity: 1,
          width: '100%'
        }} transition={{
          duration: 0.3
        }} data-id="element-1379">
            <input type="text" placeholder={language === 'en' ? 'Search users...' : 'البحث عن مستخدمين...'} className="w-full px-9 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1380" />
            <SearchIcon size={16} className="absolute left-3 top-2 text-gray-400" data-id="element-1381" />
          </motion.div>
          <motion.div className="flex flex-wrap gap-2" variants={staggerContainer} data-id="element-1382">
            <motion.div className="relative" variants={listItem} data-id="element-1383">
              <select className="appearance-none px-3 py-1.5 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={filters.userType} onChange={e => handleFilterChange('userType', e.target.value)} data-id="element-1384">
                <option value="all" data-id="element-1385">
                  {language === 'en' ? 'All Types' : 'جميع الأنواع'}
                </option>
                <option value="personal" data-id="element-1386">
                  {language === 'en' ? 'Personal Account' : 'حساب شخصي'}
                </option>
                <option value="business" data-id="element-1387">
                  {language === 'en' ? 'Business Account' : 'حساب تجاري'}
                </option>
              </select>
              <ChevronDownIcon size={14} className="absolute right-2.5 top-2.5 text-gray-500 pointer-events-none" data-id="element-1388" />
            </motion.div>
            <motion.div className="relative" variants={listItem} data-id="element-1389">
              <select className="appearance-none px-3 py-1.5 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={filters.status} onChange={e => handleFilterChange('status', e.target.value)} data-id="element-1390">
                <option value="all" data-id="element-1391">
                  {language === 'en' ? 'All Status' : 'جميع الحالات'}
                </option>
                <option value="active" data-id="element-1392">
                  {language === 'en' ? 'Active' : 'نشط'}
                </option>
                <option value="blocked" data-id="element-1393">
                  {language === 'en' ? 'Blocked' : 'محظور'}
                </option>
              </select>
              <ChevronDownIcon size={14} className="absolute right-2.5 top-2.5 text-gray-500 pointer-events-none" data-id="element-1394" />
            </motion.div>
            <motion.div className="relative" variants={listItem} data-id="element-1395">
              <select className="appearance-none px-3 py-1.5 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-congress-blue-500 focus:border-congress-blue-500" value={filters.timeFrame} onChange={e => handleFilterChange('timeFrame', e.target.value)} data-id="element-1396">
                <option value="all" data-id="element-1397">
                  {language === 'en' ? 'All Time' : 'كل الوقت'}
                </option>
                <option value="30days" data-id="element-1398">
                  {language === 'en' ? 'Last 30 days' : 'آخر 30 يوم'}
                </option>
                <option value="90days" data-id="element-1399">
                  {language === 'en' ? 'Last 90 days' : 'آخر 90 يوم'}
                </option>
                <option value="year" data-id="element-1400">
                  {language === 'en' ? 'Last year' : 'العام الماضي'}
                </option>
              </select>
              <ChevronDownIcon size={14} className="absolute right-2.5 top-2.5 text-gray-500 pointer-events-none" data-id="element-1401" />
            </motion.div>
            <motion.button className="px-3 py-1.5 bg-gray-50 text-gray-700 rounded-md flex items-center hover:bg-gray-100 transition-colors text-sm border border-gray-200" variants={listItem} whileHover={buttonHover} whileTap={buttonTap} data-id="element-1402">
              <FilterIcon size={14} className={language === 'en' ? 'mr-1.5' : 'ml-1.5'} data-id="element-1403" />
              {language === 'en' ? 'Filter' : 'تصفية'}
            </motion.button>
          </motion.div>
        </motion.div>
        <div className="overflow-x-auto" data-id="element-1404">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1405">
            <thead data-id="element-1406">
              <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1407">
                <th scope="col" className="sticky left-0 bg-gray-50 px-4 py-3 border-b border-gray-200" data-id="element-1408">
                  {language === 'en' ? 'User' : 'المستخدم'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-1409">
                  {language === 'en' ? 'Contact Info' : 'معلومات الاتصال'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-1410">
                  {language === 'en' ? 'Account Type' : 'نوع الحساب'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-right" data-id="element-1411">
                  {language === 'en' ? 'Total Orders' : 'إجمالي الطلبات'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-right" data-id="element-1412">
                  {language === 'en' ? 'Wallet Balance' : 'رصيد المحفظة'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200 text-center" data-id="element-1413">
                  {language === 'en' ? 'Addresses' : 'العناوين'}
                </th>
                <th scope="col" className="px-4 py-3 border-b border-gray-200" data-id="element-1414">
                  {language === 'en' ? 'Status' : 'الحالة'}
                </th>
                <th scope="col" className="sticky right-0 bg-gray-50 px-4 py-3 border-b border-gray-200 text-right" data-id="element-1415">
                  {language === 'en' ? 'Actions' : 'الإجراءات'}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100" data-id="element-1416">
              <AnimatePresence data-id="element-1417">
                {filteredUsers.map((user, index) => <motion.tr key={user.id} className="hover:bg-gray-50 text-sm" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0,
                transition: {
                  delay: index * 0.05,
                  duration: 0.3
                }
              }} exit={{
                opacity: 0,
                y: -20
              }} whileHover={{
                backgroundColor: 'rgba(249, 250, 251, 0.5)'
              }} data-id="element-1418">
                    <td className="sticky left-0 bg-white group-hover:bg-gray-50 px-4 py-3 whitespace-nowrap" data-id="element-1419">
                      <div className="flex items-center" data-id="element-1420">
                        <motion.div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" whileHover={{
                      scale: 1.1
                    }} data-id="element-1421">
                          <UserIcon size={16} className="text-gray-500" data-id="element-1422" />
                        </motion.div>
                        <div className="ml-3" data-id="element-1423">
                          <div className="font-medium text-gray-900" data-id="element-1424">
                            {user.name}
                          </div>
                          <div className="text-gray-500 text-xs" data-id="element-1425">{user.id}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1426">
                      <div className="text-gray-900" data-id="element-1427">{user.phone}</div>
                      <div className="text-gray-500 text-xs" data-id="element-1428">{user.email}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1429">
                      <div className="flex items-center text-gray-500" data-id="element-1430">
                        {user.type === 'personal' ? <>
                            <UserCircleIcon size={14} className={language === 'en' ? 'mr-1' : 'ml-1'} data-id="element-1431" />
                            {language === 'en' ? 'Personal' : 'شخصي'}
                          </> : <>
                            <BriefcaseIcon size={14} className={language === 'en' ? 'mr-1' : 'ml-1'} data-id="element-1432" />
                            {language === 'en' ? 'Business' : 'تجاري'}
                          </>}
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-gray-700 text-right" data-id="element-1433">
                      {user.totalOrders}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-gray-700 text-right" data-id="element-1434">
                      {user.walletBalance}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-gray-700 text-center" data-id="element-1435">
                      {user.savedAddresses}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap" data-id="element-1436">
                      <motion.span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${user.status === 'active' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`} initial={{
                    scale: 0.9
                  }} animate={{
                    scale: 1
                  }} whileHover={{
                    scale: 1.05
                  }} data-id="element-1437">
                        <span className={`h-1.5 w-1.5 rounded-full ${user.status === 'active' ? 'bg-green-500' : 'bg-red-500'} mr-1`} data-id="element-1438"></span>
                        {user.status === 'active' ? language === 'en' ? 'Active' : 'نشط' : language === 'en' ? 'Blocked' : 'محظور'}
                      </motion.span>
                    </td>
                    <td className="sticky right-0 bg-white group-hover:bg-gray-50 px-4 py-3 whitespace-nowrap text-right" data-id="element-1439">
                      <div className="flex justify-end space-x-1" data-id="element-1440">
                        <motion.button className="p-1.5 text-congress-blue-600 bg-congress-blue-50 hover:bg-congress-blue-100 rounded transition-colors" title={language === 'en' ? 'View Profile' : 'عرض الملف'} whileHover={{
                      scale: 1.1
                    }} whileTap={{
                      scale: 0.95
                    }} data-id="element-1441">
                          <EyeIcon size={16} data-id="element-1442" />
                        </motion.button>
                        <motion.button className={`p-1.5 rounded transition-colors ${user.status === 'active' ? 'text-red-600 bg-red-50 hover:bg-red-100' : 'text-green-600 bg-green-50 hover:bg-green-100'}`} title={user.status === 'active' ? language === 'en' ? 'Block User' : 'حظر المستخدم' : language === 'en' ? 'Unblock User' : 'إلغاء حظر المستخدم'} whileHover={{
                      scale: 1.1
                    }} whileTap={{
                      scale: 0.95
                    }} data-id="element-1443">
                          {user.status === 'active' ? <Ban size={16} data-id="element-1444" /> : <CheckCircle2Icon size={16} data-id="element-1445" />}
                        </motion.button>
                      </div>
                    </td>
                  </motion.tr>)}
              </AnimatePresence>
            </tbody>
          </table>
        </div>
        <motion.div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between bg-white" variants={slideUp} data-id="element-1446">
          <div className="text-xs text-gray-500" data-id="element-1447">
            {language === 'en' ? `Showing 1 to ${filteredUsers.length} of ${filteredUsers.length} users` : `عرض 1 إلى ${filteredUsers.length} من ${filteredUsers.length} مستخدم`}
          </div>
          <div className="flex items-center" data-id="element-1448">
            <div className="flex text-xs text-gray-500 items-center mr-4" data-id="element-1449">
              <span className="mr-1" data-id="element-1450">
                {language === 'en' ? 'Rows per page:' : 'صفوف في الصفحة:'}
              </span>
              <select className="appearance-none bg-transparent text-gray-700 font-medium" data-id="element-1451">
                <option data-id="element-1452">10</option>
                <option data-id="element-1453">20</option>
                <option data-id="element-1454">50</option>
              </select>
            </div>
            <nav className="flex space-x-1" aria-label="Pagination" data-id="element-1455">
              <motion.button className="inline-flex items-center px-2 py-1 border border-gray-300 rounded text-xs font-medium text-gray-500 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" whileHover={buttonHover} whileTap={buttonTap} data-id="element-1456">
                {direction === 'rtl' ? <ChevronRightIcon size={14} className="ml-0.5" data-id="element-1457" /> : <ChevronLeftIcon size={14} className="mr-0.5" data-id="element-1458" />}
                {language === 'en' ? 'Prev' : 'السابق'}
              </motion.button>
              <motion.button className="inline-flex items-center px-2 py-1 border border-gray-300 rounded text-xs font-medium text-gray-500 bg-white hover:bg-gray-50" whileHover={buttonHover} whileTap={buttonTap} data-id="element-1459">
                {language === 'en' ? 'Next' : 'التالي'}
                {direction === 'rtl' ? <ChevronLeftIcon size={14} className="mr-0.5" data-id="element-1460" /> : <ChevronRightIcon size={14} className="ml-0.5" data-id="element-1461" />}
              </motion.button>
            </nav>
          </div>
        </motion.div>
      </motion.div>
    </motion.div>;
};